import { z } from 'zod';

export const telephoneTraceSchema = z.object({
    telephoneNo: z.string({ error: 'Telephone Number is required' })
        .min(1, 'Telephone Number is required')
        .regex(/^\d+$/, "Telephone Number must be numeric"),
    telephoneCode: z.string()
        .regex(/^\d+$/, "Telephone Code must be numeric")
        .min(3, "Telephone Code must be at least 3 characters")
        .optional().or(z.literal('')),
    surname: z.string().optional().or(z.literal('')),
    yourReference: z.string().optional().or(z.literal('')),
    voucherCode: z.string().optional().or(z.literal('')),
});

export type TelephoneTracePayload = z.infer<typeof telephoneTraceSchema>;

// ── Data contract types ────────────────────────────────────────────────────

export interface TelephoneMatchItem {
    consumer_id: string | null;
    first_name: string | null;
    surname: string | null;
    id_no: string | null;
    birth_date: string | null;
    enquiry_id: string;
    enquiry_result_id: string;
    reference: string | null;
}

export interface TelephoneMatchResponse {
    success: boolean;
    message: string;
    log_id: string;
    matches: TelephoneMatchItem[];
}

export interface TelephoneResultPayload {
    enquiryId: number;
    enquiryResultId: number;
    yourReference?: string;
    voucherCode?: string;
}

export interface TelephoneTraceResponse {
    message: string;
    success: boolean;
    log_id: string;
    report_data: any;
}

// ── API calls ──────────────────────────────────────────────────────────────

const BASE_URL = '/verification/telephone-trace';

export const telephoneTraceService = {
    createPayload: (formData: z.infer<typeof telephoneTraceSchema>): TelephoneTracePayload => ({
        ...formData,
    }),

    getMatch: async (payload: TelephoneTracePayload): Promise<TelephoneMatchResponse> => {
        const axios = (await import('../axiosConfig')).default;
        const response = await axios.post<TelephoneMatchResponse>(`${BASE_URL}/match`, payload);
        return response.data;
    },

    getResult: async (payload: TelephoneResultPayload): Promise<TelephoneTraceResponse> => {
        const axios = (await import('../axiosConfig')).default;
        const response = await axios.post<TelephoneTraceResponse>(`${BASE_URL}/result`, payload);
        return response.data;
    },
};
